import { useState, useCallback, useEffect } from "react";
import Link from "next/link";

import { api } from "@utils/api";
import { useApp } from "@context/AppProvider";
import styles from "@styles/dropAuction/dropAuctionLive.module.scss";

import AuctionItemCard from "./AuctionItemCard";

const LiveAuction = ({ heading, subHeading }) => {
  const {
    idb: { session },
  } = useApp();
  const [data, setData] = useState({
    check: false,
    auctionData: [],
    totalAuctions: 0,
  });

  const getLiveAuction = useCallback(async () => {
    const liveAuctionData = await api(
      {
        url: "/auction",
        method: "POST",
        data: {
          category: null,
          pageNumber: 0,
          // eslint-disable-next-line babel/camelcase
          price_from: null,
          // eslint-disable-next-line babel/camelcase
          price_to: null,
        },
      },
      session
    );
    if (liveAuctionData && liveAuctionData.status) {
      setData({
        check: true,
        auctionData:
          liveAuctionData.results.length > 4
            ? liveAuctionData.results.splice(0, 4)
            : liveAuctionData.results,
        totalAuctions: liveAuctionData.total,
      });
    }
  }, [session]);

  useEffect(() => {
    if (!data.check && session) {
      getLiveAuction();
    }
  }, [data.check, getLiveAuction, session]);
  let html = "";
  if (data.totalAuctions) {
    html = (
      <div className={styles.goAgianSec}>
        <div className={styles.goAgianInner}>
          <div className={styles.globalHeading}>
            <h2>{heading}</h2>
            <p className="mb-10">{subHeading}</p>
          </div>
          <div className="container">
            <div className={`row ${styles.goItemsNew}`}>
              {data.auctionData &&
                data.auctionData.length > 0 &&
                data.auctionData.map((data, index) => (
                  <div
                    className={`customCol ${styles.goItem}`}
                    id={data.auction_time_utc + index}
                    key={data.auction_time_utc + index}
                  >
                    <AuctionItemCard data={data} />
                  </div>
                ))}
            </div>
            {data.totalAuctions >= 4 && (
              <div className={styles.seeMore}>
                <Link href="/drop-auctions/all" passHref>
                  <p className={`${styles.btnCustom} ${styles.liveAuctionBtn}`}>
                    See all Drops
                  </p>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
  return html;
};

export default LiveAuction;
